module.exports = __webpack_public_path__ + "442be0db48ce61e4a9ebbe6dc9b17bd8.png";